import { createAsyncThunk } from '@reduxjs/toolkit';
import { loadMindlyReview, reviewMindly } from '../../api/mindlyReviews';

export const reviewMindlyThunk = createAsyncThunk(
  'mindlyReviews/review',
  async (payload: { rate?: number; comment?: string }) => {
    const response = await reviewMindly(payload.rate, payload.comment);
    return response;
  }
);

export const loadMindlyReviewThunk = createAsyncThunk('mindlyReviews/load', async () => {
  const response = await loadMindlyReview();
  return response;
});
